import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Tooltip, Avatar, Button, Modal, Input, Form, message } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { cloneDeep } from "lodash-es";
import { useSelector, useDispatch } from "react-redux";
import VerifyCodeBtn from "@/components/VerifyCodeBtn";
import VerifyImg from "@/components/verify";

import { format, hmacSHA256 } from "@/utils";
import { loginUrl } from "@/utils/base";
import { passwordReg, phoneReg, userNameReg } from "@/utils/constant";

import api from "@/api";
import dataJson from "@/../public/data.json";

const INPUT_HEIGHT = 38;
const prefix = "info";
import "./index.less";
import InfoTab from "./InfoTab";
import { useEventListener } from "ahooks";
import messageDispatchCenter from "@/utils/messageDispatchCenter";
import { MESSAGE_ON_TYPE } from "@/types/message";

// {
//   "key": "22",
//   "img": "https://kaihong-developer.obs.cn-south-1.myhuaweicloud.com/developer/default/public/resources/v2/images/account/account_exit_icon.png",
//   "title": "注销账号",
//   "handleBtn": "注销",
//   "modalTitle": "注销账号",
//   "codeApi": "getCodeCancel",
//   "verifyCodeApi": "verifyCodeCancel",
//   "modeOpenFnc": "setOpen4"
// }

function Info() {
  const { user, account, req_err } = dataJson;
  const infoRef=useRef<any>(null);
  const [modalTitle, setModalTitle] = useState("");
  const [infoList, setInfoList] = useState<any[]>(user.account_info_list);
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [confirmLoading1, setConfirmLoading1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [confirmLoading2, setConfirmLoading2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [confirmLoading3, setConfirmLoading3] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [confirmLoading4, setConfirmLoading4] = useState(false);
  const [codeValue, setCodeValue] = useState<any>();
  const [codeValue2, setCodeValue2] = useState<any>();
  const [codeToken, setCodeToken] = useState<any>();
  const [isNewPhoneValueOk, setIsNewPhoneValueOk] = useState(false);
  const [isFirst, setIsFirst] = useState(true);
  const [open5, setOpen5] = useState(false);
  const apiCode = useRef<any>();
  const apiVerifyCode = useRef<any>();
  const modeOpenFnc = useRef<any>();

  const [verifyPhoneForm] = Form.useForm();
  const [newPhoneForm] = Form.useForm();
  const [userNameForm] = Form.useForm();
  const [newPasswordForm] = Form.useForm();
  const newPhoneValue = Form.useWatch("receiver", newPhoneForm);

  const dispatch = useDispatch();
  const userDataChange = useSelector((state: any) => state.userDataChange);
  const userData = useSelector((state: any) => state.userData);

  const navigate = useNavigate();
  const apiCopy: any = api;

  const setOpenObj: any = {
    setOpen1,
    setOpen2,
    setOpen3,
    setOpen4,
  };

  const updateUser = () => {
    dispatch({
      type: "setUserDataChange",
      payload: userDataChange + 1,
    });
  };

  const beforeClick = (params: any) => {
    const checkNewPhonePromise = new Promise((resolve, reject) => {
      api
        .checkNewPhone({
          receiver: newPhoneValue,
          validate: {
            type: params?.type,
            token: params?.token,
          },
        })
        .then((resp: any) => {
          if (resp.code === 200) {
            if (resp.data.validate) {
              resolve(resp);
            } else {
              window.message.error(resp.data.msg);
            }
          } else {
            window.message.error(resp.msg || req_err);
          }
        });
    });
    return checkNewPhonePromise;
  };

  const setInfoListData = () => {
    try {
      const accountInfoList = cloneDeep(user.account_info_list);
      const accountInfoListMap = accountInfoList.map((item) => {
        const newItem = item.list.map((ele: any) => {
          if (ele.key === "11") {
            const eleObj = {
              ...ele,
              value: userData?.userName,
            };
            if (userData?.additional?.userNameChange !== "0") {
              eleObj.tip = `账号名是开放平台账号的唯一凭证，可用于登录，只能修改一次。 您已于${format(
                new Date(Number(userData?.additional?.userNameChangeTime)),
                "yyyy年MM月dd日"
              )}修改了账号名。`;
              delete eleObj.handleBtn;
            }
            return eleObj;
          } else if (ele.key === "12") {
            return {
              ...ele,
              value: userData?.phone,
            };
          } else {
            return ele;
          }
        });
        return { ...item, list: newItem };
      });
      setInfoList(accountInfoListMap);
    } catch (error) {
      console.error(error);
    }
  };

  const handleBtn = (ele: any) => {
    setModalTitle(ele.modalTitle);
    setOpen(true);
    apiCode.current = apiCopy[ele.codeApi];
    apiVerifyCode.current = apiCopy[ele.verifyCodeApi];
    modeOpenFnc.current = setOpenObj[ele.modeOpenFnc];
  };

  const passwordChange = () => {
    const passwordConfirmValue = newPasswordForm.getFieldValue("passwordConfirm");
    if (passwordConfirmValue) {
      newPasswordForm.validateFields(["passwordConfirm"]);
    }
  };

  const handleOk5 = () => {
    setOpen5(false);
  };

  const handleCancel5 = () => {
    setOpen5(false);
  };
  const verifyCheckEnd = async (params: any) => {
    setOpen5(false);
    try {
      const userNameVal = userNameForm.getFieldValue("userName");
      const res: any = await api.checkUserName({
        userName: userNameVal,
        validate: {
          type: params?.type,
          token: params?.token,
        },
      });
      if (res.code === 200) {
        if (res.data === true) {
          window.message.error("该账号名已存在");
          setConfirmLoading1(false);
        } else {
          const res: any = await api.userUpdateName({
            userName: userNameVal,
            validate: {
              code: codeToken?.code,
              type: codeToken?.type,
              function: codeToken?.function,
              token: hmacSHA256(codeToken?.token, codeToken?.secret),
            },
          });
          if (res.code === 200) {
            setOpen1(false);
            setConfirmLoading1(false);
            updateUser();
          } else {
            setConfirmLoading1(false);
            window.message.error(res.msg || req_err);
          }
        }
      }
    } catch (errorInfo: any) {
      setConfirmLoading1(false);
      console.error(errorInfo);
    }
  };

  const handleOk = async () => {
    try {
      const values = await verifyPhoneForm.validateFields();
      setConfirmLoading(true);
      const res: any = await apiVerifyCode.current({
        validate: {
          code: values?.code,
          type: codeValue?.type,
          function: codeValue?.function,
          token: hmacSHA256(codeValue?.token, codeValue?.secret),
        },
      });
      if (res.code === 200) {
        setOpen(false);
        setCodeToken(res.data);
        setConfirmLoading(false);
        modeOpenFnc.current(true);
        setIsFirst(true);
      } else {
        setConfirmLoading(false);
        window.message.error(res.msg || req_err);
      }
    } catch (errorInfo: any) {
      console.error(errorInfo);
      setConfirmLoading(false);
    }
  };
  const handleCancel = () => {
    setOpen(false);
    setCodeValue(null);
  };

  const handleOk1 = async () => {
    try {
      await userNameForm.validateFields();
      setConfirmLoading1(true);
      setOpen5(true);
    } catch (errorInfo: any) {
      setConfirmLoading1(false);
      console.error(errorInfo);
    }
  };
  const handleCancel1 = () => {
    setOpen1(false);
    setCodeToken(null);
  };

  const handleOk2 = async () => {
    try {
      const values = await newPhoneForm.validateFields();
      setConfirmLoading2(true);
      try {
        const res: any = await api.userUpdatePhone({
          receiver: newPhoneValue,
          validate: {
            code: values?.code,
            type: codeValue2?.phoneResult?.type,
            function: codeValue2?.phoneResult?.function,
            token: hmacSHA256(codeValue2?.phoneResult?.token, codeValue2?.phoneResult?.secret),
          },
        });
        if (res.code === 200) {
          setOpen2(false);
          setConfirmLoading2(false);
          setIsFirst(true);
          updateUser();
        } else {
          setConfirmLoading2(false);
          setIsFirst(true);
          window.message.error(res.msg || req_err);
        }
      } catch (errorInfo: any) {
        setIsFirst(true);
        setConfirmLoading2(false);
        console.error(errorInfo);
      }
    } catch (errorInfo: any) {
      setConfirmLoading2(false);
      console.error(errorInfo);
    }
  };
  const handleCancel2 = () => {
    setOpen2(false);
    setIsFirst(true);
    setCodeToken(null);
    setCodeValue2(null);
  };

  const handleOk3 = async () => {
    try {
      const values = await newPasswordForm.validateFields();
      setConfirmLoading3(true);
      try {
        const res: any = await api.userUpdatePwd({
          password: values?.password,
          validate: {
            code: codeToken?.code,
            type: codeToken?.type,
            function: codeToken?.function,
            token: hmacSHA256(codeToken?.token, codeToken?.secret),
          },
        });
        if (res.code === 200) {
          setOpen3(false);
          setConfirmLoading3(false);
          updateUser();
        } else {
          setConfirmLoading3(false);
          window.message.error(res.msg || req_err);
        }
      } catch (errorInfo: any) {
        setConfirmLoading3(false);
        console.error(errorInfo);
      }
    } catch (errorInfo: any) {
      setConfirmLoading3(false);
      console.error(errorInfo);
    }
  };
  const handleCancel3 = () => {
    setOpen3(false);
    setCodeToken(null);
  };

  const handleOk4 = async () => {
    try {
      setConfirmLoading4(true);
      const res: any = await api.userCancel({
        validate: {
          code: codeToken?.code,
          type: codeToken?.type,
          function: codeToken?.function,
          token: hmacSHA256(codeToken?.token, codeToken?.secret),
        },
      });
      if (res.code === 200) {
        setOpen4(false);
        setConfirmLoading4(false);
        navigate(loginUrl);
      } else {
        setConfirmLoading4(false);
        window.message.error(res.msg || req_err);
      }
    } catch (errorInfo: any) {
      console.error(errorInfo);
      setConfirmLoading4(false);
    }
  };
  const handleCancel4 = () => {
    setOpen4(false);
    setCodeToken(null);
  };

  const setCode = (params: any) => {
    setCodeValue(params);
  };

  const setCode2 = (params: any) => {
    setIsFirst(params?.isFirst);
    setCodeValue2(params);
  };

  useEffect(() => {
    newPhoneValue &&
      newPhoneForm.validateFields(["receiver"]).then(
        () => {
          setIsNewPhoneValueOk(true);
        },
        () => {
          setIsNewPhoneValueOk(false);
        }
      );
  }, [newPhoneValue]);
  useEffect(() => {
    JSON.stringify(userData) != "{}" && setInfoListData();
  }, [userData]);

  useEventListener("scroll",(e)=>{
    messageDispatchCenter.emit(MESSAGE_ON_TYPE.SCROLL);
  },{
    target: infoRef
  })


  return (
    <div className={prefix}>
      <div className={`${prefix}-content`} ref={infoRef}>
        <div className={`${prefix}-content-info`} >
          {
            JSON.stringify(userData) != "{}" &&<Avatar icon={<img src={userData?.avatar} className={`${prefix}-info-avatar-img`} />} className={`${prefix}-info-avatar`} />
          }
          {
            JSON.stringify(userData) != "{}" && <div className={`${prefix}-info-data`}>
            <div>
              <Tooltip
                placement="left"
                title={infoList[0].list[0].tip}
                overlayClassName={`${prefix}-item-content-tooltip`}
                color="#fff"
              >
                <QuestionCircleOutlined style={{ color: "#0A59F7", cursor: "pointer", marginRight: 4 }} />
              </Tooltip>

              <span>{user.account_name}</span>
              {userData?.userName}
              <Button type="link" onClick={() => handleBtn(infoList[0].list[0])} className={`${prefix}-item-content-btn`}>
                修改
              </Button>
            </div>
            <div>
              <span>{user.account_phone}</span>
              {userData?.phone}
              <Button type="link" onClick={() => handleBtn(infoList[0].list[1])} className={`${prefix}-item-content-btn`}>
                修改
              </Button>
            </div>
            <div>
              <span>{user.account_type}</span>
              {user.user_type[userData?.additional?.userType as keyof typeof user.user_type]}
            </div>
            <div>
              <span>{user.account_date}</span>
              {userData?.createTime ? format(new Date(Number(userData?.createTime)), "yyyy/MM/dd") : ""}
            </div>
            <div>
              <span>登录密码</span>
              <Button type="link" onClick={() => handleBtn(infoList[1].list[0])} className={`${prefix}-item-content-btn`}>
                修改
              </Button>
            </div>
          </div>
          }
        </div>
      </div>
      <Modal
        title={modalTitle}
        centered
        open={open}
        width={430}
        destroyOnClose
        confirmLoading={confirmLoading}
        cancelText="取消"
        okText="确定"
        onCancel={handleCancel}
        onOk={handleOk}
        maskClosable={false}
        cancelButtonProps={{ disabled: confirmLoading }}
        afterOpenChange={(open: boolean) => !open && verifyPhoneForm.resetFields()}
        className={`${prefix}-modal`}
      >
        <p className={`${prefix}-modal-title`}>{user.verify_identity}</p>
        <div className={`${prefix}-modal-phone`}>{userData?.phone}</div>
        <Form className={`${prefix}-modal-form`} form={verifyPhoneForm} autoComplete="off">
          <div className={`${prefix}-modal-code`}>
            <Form.Item name="code" rules={[{ required: true, message: account.code_message }]}>
              <Input placeholder={account.code_placeholder} style={{ width: 242, height: INPUT_HEIGHT }} />
            </Form.Item>
            <VerifyCodeBtn phoneNumber={userData?.phone} apiFnc={apiCode.current} width={132} height={INPUT_HEIGHT} fontSize={14} reqData={null} reload={setCode} />
          </div>
        </Form>
      </Modal>
      <Modal
        title={modalTitle}
        centered
        open={open1}
        width={430}
        destroyOnClose
        confirmLoading={confirmLoading1}
        cancelText="取消"
        okText="确定"
        onCancel={handleCancel1}
        onOk={handleOk1}
        maskClosable={false}
        cancelButtonProps={{ disabled: confirmLoading1 }}
        afterOpenChange={(open: boolean) => !open && userNameForm.resetFields()}
        className={`${prefix}-modal`}
      >
        <div className={`${prefix}-modal-account`}>{user.change_account_tip}</div>
        <Form className={`${prefix}-modal-form`} form={userNameForm} autoComplete="off">
          <Form.Item
            name="userName"
            rules={[
              { required: true, message: user.change_account_placeholder },
              {
                pattern: userNameReg,
                message: user.message_change_account,
              },
            ]}
          >
            <Input showCount size="large" maxLength={30} placeholder={user.change_account_placeholder} style={{ height: INPUT_HEIGHT }} />
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title={modalTitle}
        centered
        open={open2}
        width={430}
        destroyOnClose
        confirmLoading={confirmLoading2}
        cancelText="取消"
        okText="确定"
        onCancel={handleCancel2}
        onOk={handleOk2}
        maskClosable={false}
        cancelButtonProps={{ disabled: confirmLoading2 }}
        afterOpenChange={(open: boolean) => !open && newPhoneForm.resetFields()}
        className={`${prefix}-modal`}
      >
        <p className={`${prefix}-modal-title`}>{user.new_phone}</p>
        <Form className={`${prefix}-modal-form`} form={newPhoneForm} autoComplete="off">
          <Form.Item
            name="receiver"
            rules={[
              { required: true, message: account.phone_number_message },
              {
                pattern: phoneReg,
                message: account.phone_number_message,
              },
            ]}
          >
            <Input size="large" placeholder={account.phone_number_placeholder} style={{ height: INPUT_HEIGHT }} />
          </Form.Item>
          <div className={`${prefix}-modal-code`}>
            <Form.Item name="code" rules={[{ required: true, message: account.code_message }]}>
              <Input size="large" placeholder={account.code_placeholder} style={{ width: 242, height: INPUT_HEIGHT }} />
            </Form.Item>
            <VerifyCodeBtn
              phoneNumber={isNewPhoneValueOk ? newPhoneValue : ""}
              apiFnc={api.getCodeUpdateNewPhone}
              width={132}
              height={INPUT_HEIGHT}
              fontSize={14}
              reqData={{
                receiver: newPhoneValue,
                validate: isFirst
                  ? {
                      code: codeToken?.code,
                      type: codeToken?.type,
                      function: codeToken?.function,
                      token: hmacSHA256(codeToken?.token, codeToken?.secret),
                    }
                  : {
                      code: codeValue2?.tokenResult?.code,
                      type: codeValue2?.tokenResult?.type,
                      function: codeValue2?.tokenResult?.function,
                      token: hmacSHA256(codeValue2?.tokenResult?.token, codeValue2?.tokenResult?.secret),
                    },
              }}
              reload={setCode2}
              beforeClick={beforeClick}
            />
          </div>
        </Form>
      </Modal>
      <Modal
        title={modalTitle}
        centered
        open={open3}
        width={430}
        destroyOnClose
        confirmLoading={confirmLoading3}
        cancelText="取消"
        okText="确定"
        onCancel={handleCancel3}
        onOk={handleOk3}
        maskClosable={false}
        cancelButtonProps={{ disabled: confirmLoading3 }}
        afterOpenChange={(open: boolean) => !open && newPasswordForm.resetFields()}
        className={`${prefix}-modal`}
      >
        <p className={`${prefix}-modal-title`}>{account.new_password_message}</p>
        <Form className={`${prefix}-modal-form`} form={newPasswordForm} autoComplete="off">
          <Form.Item
            name="password"
            rules={[
              { required: true, message: account.new_password_message },
              {
                pattern: passwordReg,
                message: account.password_validate,
              },
            ]}
          >
            <Input.Password size="large" placeholder={account.new_password_placeholder} onChange={passwordChange} style={{ height: INPUT_HEIGHT }} />
          </Form.Item>
          <Form.Item
            name="passwordConfirm"
            rules={[
              { required: true, message: account.confirm_password_placeholder },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(account.confirm_password_err));
                },
              }),
            ]}
          >
            <Input.Password size="large" placeholder={account.confirm_password_placeholder} style={{ height: INPUT_HEIGHT }} />
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title={modalTitle}
        centered
        open={open4}
        width={430}
        confirmLoading={confirmLoading4}
        cancelText="取消"
        okText="确定"
        onCancel={handleCancel4}
        onOk={handleOk4}
        maskClosable={false}
        cancelButtonProps={{ disabled: confirmLoading4 }}
        className={`${prefix}-modal`}
      >
        <div className={`${prefix}-modal-exit`}>{user.exit_tip}</div>
      </Modal>
      <Modal title="请完成安全验证" footer={null} width={358} destroyOnClose open={open5} onOk={handleOk5} onCancel={handleCancel5}>
        <VerifyImg verifyCheckEnd={verifyCheckEnd} />
      </Modal>
    </div>
  );
}

export default Info;
